var cr = Object.defineProperty;
var or = (e, n, r) => n in e ? cr(e, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[n] = r;
var v = (e, n, r) => or(e, typeof n != "symbol" ? n + "" : n, r);
import * as P from "protobufjs/minimal.js";
import "../../../billing/data.js";
import { Money as c } from "../../../common/currency.js";
import { DateTime as l, YearMonthDay as S } from "../../../common/time.js";
import "../../../precog/v2/common.js";
import { FullPagePaywall as q, Modal as y, PaywallCard as T, Downgrade as g, TrialWelcome as G, TrialExpiring as B, TrialExpired as C } from "../../assets.js";
import "../../common.js";
import { SquareOneEligibility as f, ActiveTrial as O, AvailableTrial as F, ConsumedTrial as $, Subscription as u, PlanGroup as p, Pricing as b, Duration as L, Usage as h, ActivationSource as A, Entity as D, EligibilityQualifier as I, Feedback as W, PlanComponent as U, SubscriptionKey as M, Bundle as o, BundleOffering as w, FeedbackOptionList as N, DisplayedFeature as d } from "../../data.js";
import { ListFeatureStatusesResponse as dr, BatchCreateAndCancelSubscriptionsRequest_CreateSubscription as _, BatchCreateAndCancelSubscriptionsRequest_CancelSubscription as K, BatchCreateAndCancelSubscriptionsRequest_UpdateSubscription as Q, BulkGetFeatureDiffRequest_PlanChange as V } from "../../subscription_service.js";
const s = "default" in P ? P.default : P;
function Y() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsRequest",
    createRequests: [],
    cancelRequests: [],
    updateRequests: [],
    reason: void 0
  };
}
const rn = {
  $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsRequest",
  encode(e, n = s.Writer.create()) {
    for (const r of e.createRequests)
      _.encode(r, n.uint32(10).fork()).ldelim();
    for (const r of e.cancelRequests)
      K.encode(r, n.uint32(18).fork()).ldelim();
    for (const r of e.updateRequests)
      Q.encode(r, n.uint32(34).fork()).ldelim();
    return e.reason !== void 0 && n.uint32(26).string(e.reason), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Y();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.createRequests.push(_.decode(r, r.uint32()));
          continue;
        case 2:
          if (t !== 18)
            break;
          i.cancelRequests.push(K.decode(r, r.uint32()));
          continue;
        case 4:
          if (t !== 34)
            break;
          i.updateRequests.push(Q.decode(r, r.uint32()));
          continue;
        case 3:
          if (t !== 26)
            break;
          i.reason = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return rn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r, a, i;
    const n = Y();
    return n.createRequests = ((r = e.createRequests) == null ? void 0 : r.map((t) => _.fromPartial(t))) || [], n.cancelRequests = ((a = e.cancelRequests) == null ? void 0 : a.map((t) => K.fromPartial(t))) || [], n.updateRequests = ((i = e.updateRequests) == null ? void 0 : i.map((t) => Q.fromPartial(t))) || [], n.reason = e.reason ?? void 0, n;
  }
};
function z() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse",
    created: [],
    canceled: [],
    updated: []
  };
}
const tn = {
  $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse",
  encode(e, n = s.Writer.create()) {
    for (const r of e.created)
      m.encode(r, n.uint32(10).fork()).ldelim();
    for (const r of e.canceled)
      R.encode(r, n.uint32(18).fork()).ldelim();
    for (const r of e.updated)
      k.encode(r, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = z();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.created.push(m.decode(r, r.uint32()));
          continue;
        case 2:
          if (t !== 18)
            break;
          i.canceled.push(R.decode(r, r.uint32()));
          continue;
        case 3:
          if (t !== 26)
            break;
          i.updated.push(k.decode(r, r.uint32()));
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return tn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r, a, i;
    const n = z();
    return n.created = ((r = e.created) == null ? void 0 : r.map((t) => m.fromPartial(t))) || [], n.canceled = ((a = e.canceled) == null ? void 0 : a.map((t) => R.fromPartial(t))) || [], n.updated = ((i = e.updated) == null ? void 0 : i.map((t) => k.fromPartial(t))) || [], n;
  }
};
function H() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.CreatedSubscription",
    subscription: void 0,
    succeeded: void 0
  };
}
const m = {
  $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.CreatedSubscription",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), e.succeeded !== void 0 && n.uint32(16).bool(e.succeeded), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = H();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
        case 2:
          if (t !== 16)
            break;
          i.succeeded = r.bool();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return m.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = H();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n.succeeded = e.succeeded ?? void 0, n;
  }
};
function J() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.CanceledSubscription",
    subscription: void 0,
    succeeded: void 0
  };
}
const R = {
  $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.CanceledSubscription",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), e.succeeded !== void 0 && n.uint32(16).bool(e.succeeded), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = J();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
        case 2:
          if (t !== 16)
            break;
          i.succeeded = r.bool();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return R.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = J();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n.succeeded = e.succeeded ?? void 0, n;
  }
};
function X() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription",
    subscription: void 0,
    succeeded: void 0
  };
}
const k = {
  $type: "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), e.succeeded !== void 0 && n.uint32(16).bool(e.succeeded), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = X();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
        case 2:
          if (t !== 16)
            break;
          i.succeeded = r.bool();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return k.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = X();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n.succeeded = e.succeeded ?? void 0, n;
  }
};
function Z() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalCancelSubscriptionRequest",
    subscriptionToken: void 0,
    cancelImmediately: void 0,
    reason: void 0,
    feedback: []
  };
}
const sn = {
  $type: "squareup.sub2.service.v3.external.ExternalCancelSubscriptionRequest",
  encode(e, n = s.Writer.create()) {
    e.subscriptionToken !== void 0 && n.uint32(10).string(e.subscriptionToken), e.cancelImmediately !== void 0 && n.uint32(16).bool(e.cancelImmediately), e.reason !== void 0 && n.uint32(26).string(e.reason);
    for (const r of e.feedback)
      W.encode(r, n.uint32(34).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Z();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscriptionToken = r.string();
          continue;
        case 2:
          if (t !== 16)
            break;
          i.cancelImmediately = r.bool();
          continue;
        case 3:
          if (t !== 26)
            break;
          i.reason = r.string();
          continue;
        case 4:
          if (t !== 34)
            break;
          i.feedback.push(W.decode(r, r.uint32()));
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return sn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const n = Z();
    return n.subscriptionToken = e.subscriptionToken ?? void 0, n.cancelImmediately = e.cancelImmediately ?? void 0, n.reason = e.reason ?? void 0, n.feedback = ((r = e.feedback) == null ? void 0 : r.map((a) => W.fromPartial(a))) || [], n;
  }
};
function j() {
  return { $type: "squareup.sub2.service.v3.external.ExternalCancelSubscriptionResponse", subscription: void 0 };
}
const an = {
  $type: "squareup.sub2.service.v3.external.ExternalCancelSubscriptionResponse",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = j();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return an.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = j();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n;
  }
};
function ee() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalPauseSubscriptionRequest",
    subscriptionToken: void 0,
    resumeAt: void 0,
    resumeAtDate: void 0
  };
}
const un = {
  $type: "squareup.sub2.service.v3.external.ExternalPauseSubscriptionRequest",
  encode(e, n = s.Writer.create()) {
    return e.subscriptionToken !== void 0 && n.uint32(10).string(e.subscriptionToken), e.resumeAt !== void 0 && l.encode(e.resumeAt, n.uint32(18).fork()).ldelim(), e.resumeAtDate !== void 0 && S.encode(e.resumeAtDate, n.uint32(26).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ee();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscriptionToken = r.string();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.resumeAt = l.decode(r, r.uint32());
          continue;
        case 3:
          if (t !== 26)
            break;
          i.resumeAtDate = S.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return un.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ee();
    return n.subscriptionToken = e.subscriptionToken ?? void 0, n.resumeAt = e.resumeAt !== void 0 && e.resumeAt !== null ? l.fromPartial(e.resumeAt) : void 0, n.resumeAtDate = e.resumeAtDate !== void 0 && e.resumeAtDate !== null ? S.fromPartial(e.resumeAtDate) : void 0, n;
  }
};
function ne() {
  return { $type: "squareup.sub2.service.v3.external.ExternalPauseSubscriptionResponse", subscription: void 0 };
}
const cn = {
  $type: "squareup.sub2.service.v3.external.ExternalPauseSubscriptionResponse",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ne();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return cn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ne();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n;
  }
};
function re() {
  return { $type: "squareup.sub2.service.v3.external.ExternalResumeSubscriptionRequest", subscriptionToken: void 0 };
}
const on = {
  $type: "squareup.sub2.service.v3.external.ExternalResumeSubscriptionRequest",
  encode(e, n = s.Writer.create()) {
    return e.subscriptionToken !== void 0 && n.uint32(10).string(e.subscriptionToken), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = re();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscriptionToken = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return on.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = re();
    return n.subscriptionToken = e.subscriptionToken ?? void 0, n;
  }
};
function te() {
  return { $type: "squareup.sub2.service.v3.external.ExternalResumeSubscriptionResponse", subscription: void 0 };
}
const dn = {
  $type: "squareup.sub2.service.v3.external.ExternalResumeSubscriptionResponse",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = te();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return dn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = te();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n;
  }
};
function ie() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalCreateOrUpdateSubscriptionRequest",
    subscriptionToken: void 0,
    planToken: void 0,
    reason: void 0,
    startInFreeTrialNoObligationState: void 0,
    planBillingCycle: void 0,
    activationSource: void 0
  };
}
const ln = {
  $type: "squareup.sub2.service.v3.external.ExternalCreateOrUpdateSubscriptionRequest",
  encode(e, n = s.Writer.create()) {
    return e.subscriptionToken !== void 0 && n.uint32(10).string(e.subscriptionToken), e.planToken !== void 0 && n.uint32(18).string(e.planToken), e.reason !== void 0 && n.uint32(26).string(e.reason), e.startInFreeTrialNoObligationState !== void 0 && n.uint32(32).bool(e.startInFreeTrialNoObligationState), e.planBillingCycle !== void 0 && n.uint32(40).int32(e.planBillingCycle), e.activationSource !== void 0 && A.encode(e.activationSource, n.uint32(50).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ie();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscriptionToken = r.string();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.planToken = r.string();
          continue;
        case 3:
          if (t !== 26)
            break;
          i.reason = r.string();
          continue;
        case 4:
          if (t !== 32)
            break;
          i.startInFreeTrialNoObligationState = r.bool();
          continue;
        case 5:
          if (t !== 40)
            break;
          i.planBillingCycle = r.int32();
          continue;
        case 6:
          if (t !== 50)
            break;
          i.activationSource = A.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return ln.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ie();
    return n.subscriptionToken = e.subscriptionToken ?? void 0, n.planToken = e.planToken ?? void 0, n.reason = e.reason ?? void 0, n.startInFreeTrialNoObligationState = e.startInFreeTrialNoObligationState ?? void 0, n.planBillingCycle = e.planBillingCycle ?? void 0, n.activationSource = e.activationSource !== void 0 && e.activationSource !== null ? A.fromPartial(e.activationSource) : void 0, n;
  }
};
function se() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalCreateOrUpdateSubscriptionResponse",
    subscription: void 0
  };
}
const fn = {
  $type: "squareup.sub2.service.v3.external.ExternalCreateOrUpdateSubscriptionResponse",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = se();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return fn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = se();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n;
  }
};
function ae() {
  return { $type: "squareup.sub2.service.v3.external.ExternalGetBillerLocationTokenRequest", countryCode: void 0 };
}
const pn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetBillerLocationTokenRequest",
  encode(e, n = s.Writer.create()) {
    return e.countryCode !== void 0 && n.uint32(10).string(e.countryCode), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ae();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.countryCode = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return pn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ae();
    return n.countryCode = e.countryCode ?? void 0, n;
  }
};
function ue() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetBillerLocationTokenResponse",
    locationToken: void 0,
    countryCode: void 0
  };
}
const bn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetBillerLocationTokenResponse",
  encode(e, n = s.Writer.create()) {
    return e.locationToken !== void 0 && n.uint32(10).string(e.locationToken), e.countryCode !== void 0 && n.uint32(18).string(e.countryCode), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ue();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.locationToken = r.string();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.countryCode = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return bn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ue();
    return n.locationToken = e.locationToken ?? void 0, n.countryCode = e.countryCode ?? void 0, n;
  }
};
function ce() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetDefaultPricingInfoRequest",
    planToken: void 0,
    planBillingCycle: void 0
  };
}
const hn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetDefaultPricingInfoRequest",
  encode(e, n = s.Writer.create()) {
    return e.planToken !== void 0 && n.uint32(10).string(e.planToken), e.planBillingCycle !== void 0 && n.uint32(16).int32(e.planBillingCycle), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ce();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.planToken = r.string();
          continue;
        case 2:
          if (t !== 16)
            break;
          i.planBillingCycle = r.int32();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return hn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ce();
    return n.planToken = e.planToken ?? void 0, n.planBillingCycle = e.planBillingCycle ?? void 0, n;
  }
};
function oe() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetDefaultPricingInfoResponse",
    pricing: void 0,
    planName: void 0
  };
}
const xn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetDefaultPricingInfoResponse",
  encode(e, n = s.Writer.create()) {
    return e.pricing !== void 0 && b.encode(e.pricing, n.uint32(10).fork()).ldelim(), e.planName !== void 0 && n.uint32(18).string(e.planName), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = oe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.pricing = b.decode(r, r.uint32());
          continue;
        case 2:
          if (t !== 18)
            break;
          i.planName = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return xn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = oe();
    return n.pricing = e.pricing !== void 0 && e.pricing !== null ? b.fromPartial(e.pricing) : void 0, n.planName = e.planName ?? void 0, n;
  }
};
function de() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetPlanComponentsRequest",
    planToken: void 0,
    planBillingCycle: void 0
  };
}
const mn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetPlanComponentsRequest",
  encode(e, n = s.Writer.create()) {
    return e.planToken !== void 0 && n.uint32(10).string(e.planToken), e.planBillingCycle !== void 0 && n.uint32(16).int32(e.planBillingCycle), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = de();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.planToken = r.string();
          continue;
        case 2:
          if (t !== 16)
            break;
          i.planBillingCycle = r.int32();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return mn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = de();
    return n.planToken = e.planToken ?? void 0, n.planBillingCycle = e.planBillingCycle ?? void 0, n;
  }
};
function le() {
  return { $type: "squareup.sub2.service.v3.external.ExternalGetPlanComponentsResponse", components: [] };
}
const Rn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetPlanComponentsResponse",
  encode(e, n = s.Writer.create()) {
    for (const r of e.components)
      U.encode(r, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = le();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.components.push(U.decode(r, r.uint32()));
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Rn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const n = le();
    return n.components = ((r = e.components) == null ? void 0 : r.map((a) => U.fromPartial(a))) || [], n;
  }
};
function fe() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetPricingInfoRequest",
    planToken: void 0,
    subscriptionToken: void 0,
    usageData: void 0,
    planBillingCycle: void 0,
    includeEstimatedTax: void 0,
    bundleOfferingToken: void 0,
    bundleOfferingVersion: void 0
  };
}
const kn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetPricingInfoRequest",
  encode(e, n = s.Writer.create()) {
    return e.planToken !== void 0 && n.uint32(10).string(e.planToken), e.subscriptionToken !== void 0 && n.uint32(18).string(e.subscriptionToken), e.usageData !== void 0 && h.encode(e.usageData, n.uint32(26).fork()).ldelim(), e.planBillingCycle !== void 0 && n.uint32(32).int32(e.planBillingCycle), e.includeEstimatedTax !== void 0 && n.uint32(40).bool(e.includeEstimatedTax), e.bundleOfferingToken !== void 0 && n.uint32(50).string(e.bundleOfferingToken), e.bundleOfferingVersion !== void 0 && n.uint32(56).uint32(e.bundleOfferingVersion), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = fe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.planToken = r.string();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.subscriptionToken = r.string();
          continue;
        case 3:
          if (t !== 26)
            break;
          i.usageData = h.decode(r, r.uint32());
          continue;
        case 4:
          if (t !== 32)
            break;
          i.planBillingCycle = r.int32();
          continue;
        case 5:
          if (t !== 40)
            break;
          i.includeEstimatedTax = r.bool();
          continue;
        case 6:
          if (t !== 50)
            break;
          i.bundleOfferingToken = r.string();
          continue;
        case 7:
          if (t !== 56)
            break;
          i.bundleOfferingVersion = r.uint32();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return kn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = fe();
    return n.planToken = e.planToken ?? void 0, n.subscriptionToken = e.subscriptionToken ?? void 0, n.usageData = e.usageData !== void 0 && e.usageData !== null ? h.fromPartial(e.usageData) : void 0, n.planBillingCycle = e.planBillingCycle ?? void 0, n.includeEstimatedTax = e.includeEstimatedTax ?? void 0, n.bundleOfferingToken = e.bundleOfferingToken ?? void 0, n.bundleOfferingVersion = e.bundleOfferingVersion ?? void 0, n;
  }
};
function pe() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetPricingInfoResponse",
    pricing: void 0,
    numFreeTrialDays: void 0,
    renewalCycle: void 0,
    planName: void 0,
    estimatedCost: void 0,
    usageData: void 0,
    estimatedTaxCost: void 0,
    estimatedSubtotal: void 0,
    estimatedTaxPercentage: void 0,
    dueDate: void 0,
    estimatedProratedSubtotal: void 0,
    isProrated: void 0
  };
}
const En = {
  $type: "squareup.sub2.service.v3.external.ExternalGetPricingInfoResponse",
  encode(e, n = s.Writer.create()) {
    return e.pricing !== void 0 && b.encode(e.pricing, n.uint32(10).fork()).ldelim(), e.numFreeTrialDays !== void 0 && n.uint32(16).uint32(e.numFreeTrialDays), e.renewalCycle !== void 0 && L.encode(e.renewalCycle, n.uint32(26).fork()).ldelim(), e.planName !== void 0 && n.uint32(34).string(e.planName), e.estimatedCost !== void 0 && c.encode(e.estimatedCost, n.uint32(42).fork()).ldelim(), e.usageData !== void 0 && h.encode(e.usageData, n.uint32(50).fork()).ldelim(), e.estimatedTaxCost !== void 0 && c.encode(e.estimatedTaxCost, n.uint32(58).fork()).ldelim(), e.estimatedSubtotal !== void 0 && c.encode(e.estimatedSubtotal, n.uint32(66).fork()).ldelim(), e.estimatedTaxPercentage !== void 0 && n.uint32(72).int32(e.estimatedTaxPercentage), e.dueDate !== void 0 && l.encode(e.dueDate, n.uint32(82).fork()).ldelim(), e.estimatedProratedSubtotal !== void 0 && c.encode(e.estimatedProratedSubtotal, n.uint32(90).fork()).ldelim(), e.isProrated !== void 0 && n.uint32(96).bool(e.isProrated), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = pe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.pricing = b.decode(r, r.uint32());
          continue;
        case 2:
          if (t !== 16)
            break;
          i.numFreeTrialDays = r.uint32();
          continue;
        case 3:
          if (t !== 26)
            break;
          i.renewalCycle = L.decode(r, r.uint32());
          continue;
        case 4:
          if (t !== 34)
            break;
          i.planName = r.string();
          continue;
        case 5:
          if (t !== 42)
            break;
          i.estimatedCost = c.decode(r, r.uint32());
          continue;
        case 6:
          if (t !== 50)
            break;
          i.usageData = h.decode(r, r.uint32());
          continue;
        case 7:
          if (t !== 58)
            break;
          i.estimatedTaxCost = c.decode(r, r.uint32());
          continue;
        case 8:
          if (t !== 66)
            break;
          i.estimatedSubtotal = c.decode(r, r.uint32());
          continue;
        case 9:
          if (t !== 72)
            break;
          i.estimatedTaxPercentage = r.int32();
          continue;
        case 10:
          if (t !== 82)
            break;
          i.dueDate = l.decode(r, r.uint32());
          continue;
        case 11:
          if (t !== 90)
            break;
          i.estimatedProratedSubtotal = c.decode(r, r.uint32());
          continue;
        case 12:
          if (t !== 96)
            break;
          i.isProrated = r.bool();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return En.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = pe();
    return n.pricing = e.pricing !== void 0 && e.pricing !== null ? b.fromPartial(e.pricing) : void 0, n.numFreeTrialDays = e.numFreeTrialDays ?? void 0, n.renewalCycle = e.renewalCycle !== void 0 && e.renewalCycle !== null ? L.fromPartial(e.renewalCycle) : void 0, n.planName = e.planName ?? void 0, n.estimatedCost = e.estimatedCost !== void 0 && e.estimatedCost !== null ? c.fromPartial(e.estimatedCost) : void 0, n.usageData = e.usageData !== void 0 && e.usageData !== null ? h.fromPartial(e.usageData) : void 0, n.estimatedTaxCost = e.estimatedTaxCost !== void 0 && e.estimatedTaxCost !== null ? c.fromPartial(e.estimatedTaxCost) : void 0, n.estimatedSubtotal = e.estimatedSubtotal !== void 0 && e.estimatedSubtotal !== null ? c.fromPartial(e.estimatedSubtotal) : void 0, n.estimatedTaxPercentage = e.estimatedTaxPercentage ?? void 0, n.dueDate = e.dueDate !== void 0 && e.dueDate !== null ? l.fromPartial(e.dueDate) : void 0, n.estimatedProratedSubtotal = e.estimatedProratedSubtotal !== void 0 && e.estimatedProratedSubtotal !== null ? c.fromPartial(e.estimatedProratedSubtotal) : void 0, n.isProrated = e.isProrated ?? void 0, n;
  }
};
function be() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetSubscriptionRequest",
    subscriptionToken: void 0,
    subscriptionKey: void 0
  };
}
const vn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetSubscriptionRequest",
  encode(e, n = s.Writer.create()) {
    return e.subscriptionToken !== void 0 && n.uint32(10).string(e.subscriptionToken), e.subscriptionKey !== void 0 && M.encode(e.subscriptionKey, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = be();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscriptionToken = r.string();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.subscriptionKey = M.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return vn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = be();
    return n.subscriptionToken = e.subscriptionToken ?? void 0, n.subscriptionKey = e.subscriptionKey !== void 0 && e.subscriptionKey !== null ? M.fromPartial(e.subscriptionKey) : void 0, n;
  }
};
function he() {
  return { $type: "squareup.sub2.service.v3.external.ExternalGetSubscriptionResponse", subscription: void 0 };
}
const Pn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetSubscriptionResponse",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = he();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Pn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = he();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n;
  }
};
function xe() {
  return { $type: "squareup.sub2.service.v3.external.ExternalIsSubscribedToFeatureRequest", feature: void 0 };
}
const Sn = {
  $type: "squareup.sub2.service.v3.external.ExternalIsSubscribedToFeatureRequest",
  encode(e, n = s.Writer.create()) {
    return e.feature !== void 0 && n.uint32(8).int32(e.feature), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = xe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 8)
            break;
          i.feature = r.int32();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Sn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = xe();
    return n.feature = e.feature ?? void 0, n;
  }
};
function me() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalIsSubscribedToFeatureResponse",
    isSubscribed: void 0,
    subscriptionStatus: void 0,
    subscriptionToken: void 0
  };
}
const qn = {
  $type: "squareup.sub2.service.v3.external.ExternalIsSubscribedToFeatureResponse",
  encode(e, n = s.Writer.create()) {
    return e.isSubscribed !== void 0 && n.uint32(8).bool(e.isSubscribed), e.subscriptionStatus !== void 0 && n.uint32(16).int32(e.subscriptionStatus), e.subscriptionToken !== void 0 && n.uint32(26).string(e.subscriptionToken), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = me();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 8)
            break;
          i.isSubscribed = r.bool();
          continue;
        case 2:
          if (t !== 16)
            break;
          i.subscriptionStatus = r.int32();
          continue;
        case 3:
          if (t !== 26)
            break;
          i.subscriptionToken = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return qn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = me();
    return n.isSubscribed = e.isSubscribed ?? void 0, n.subscriptionStatus = e.subscriptionStatus ?? void 0, n.subscriptionToken = e.subscriptionToken ?? void 0, n;
  }
};
function Re() {
  return { $type: "squareup.sub2.service.v3.external.ExternalListFeatureStatusesRequest" };
}
const yn = {
  $type: "squareup.sub2.service.v3.external.ExternalListFeatureStatusesRequest",
  encode(e, n = s.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Re();
    for (; r.pos < a; ) {
      const t = r.uint32();
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return yn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Re();
  }
};
function ke() {
  return { $type: "squareup.sub2.service.v3.external.ExternalListMergedSubscriptionsRequest" };
}
const Tn = {
  $type: "squareup.sub2.service.v3.external.ExternalListMergedSubscriptionsRequest",
  encode(e, n = s.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ke();
    for (; r.pos < a; ) {
      const t = r.uint32();
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Tn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return ke();
  }
};
function Ee() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalListMergedSubscriptionsResponse",
    subscription: [],
    bundles: []
  };
}
const gn = {
  $type: "squareup.sub2.service.v3.external.ExternalListMergedSubscriptionsResponse",
  encode(e, n = s.Writer.create()) {
    for (const r of e.subscription)
      u.encode(r, n.uint32(10).fork()).ldelim();
    for (const r of e.bundles)
      o.encode(r, n.uint32(18).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ee();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription.push(u.decode(r, r.uint32()));
          continue;
        case 2:
          if (t !== 18)
            break;
          i.bundles.push(o.decode(r, r.uint32()));
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return gn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r, a;
    const n = Ee();
    return n.subscription = ((r = e.subscription) == null ? void 0 : r.map((i) => u.fromPartial(i))) || [], n.bundles = ((a = e.bundles) == null ? void 0 : a.map((i) => o.fromPartial(i))) || [], n;
  }
};
function ve() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetPlanGroupRequest",
    token: void 0,
    subscriber: void 0,
    groupBillingCycle: void 0
  };
}
const Gn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetPlanGroupRequest",
  encode(e, n = s.Writer.create()) {
    return e.token !== void 0 && n.uint32(10).string(e.token), e.subscriber !== void 0 && D.encode(e.subscriber, n.uint32(18).fork()).ldelim(), e.groupBillingCycle !== void 0 && n.uint32(24).int32(e.groupBillingCycle), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ve();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.token = r.string();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.subscriber = D.decode(r, r.uint32());
          continue;
        case 3:
          if (t !== 24)
            break;
          i.groupBillingCycle = r.int32();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Gn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ve();
    return n.token = e.token ?? void 0, n.subscriber = e.subscriber !== void 0 && e.subscriber !== null ? D.fromPartial(e.subscriber) : void 0, n.groupBillingCycle = e.groupBillingCycle ?? void 0, n;
  }
};
function Pe() {
  return { $type: "squareup.sub2.service.v3.external.ExternalGetPlanGroupResponse", planGroup: void 0 };
}
const Bn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetPlanGroupResponse",
  encode(e, n = s.Writer.create()) {
    return e.planGroup !== void 0 && p.encode(e.planGroup, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Pe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.planGroup = p.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Bn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Pe();
    return n.planGroup = e.planGroup !== void 0 && e.planGroup !== null ? p.fromPartial(e.planGroup) : void 0, n;
  }
};
function Se() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalUpdateSubscriptionRequest",
    subscription: void 0,
    startInFreeTrialNoObligationState: void 0,
    cancelFutureDowngrade: void 0,
    reason: void 0
  };
}
const Cn = {
  $type: "squareup.sub2.service.v3.external.ExternalUpdateSubscriptionRequest",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), e.startInFreeTrialNoObligationState !== void 0 && n.uint32(16).bool(e.startInFreeTrialNoObligationState), e.cancelFutureDowngrade !== void 0 && n.uint32(24).bool(e.cancelFutureDowngrade), e.reason !== void 0 && n.uint32(34).string(e.reason), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Se();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
        case 2:
          if (t !== 16)
            break;
          i.startInFreeTrialNoObligationState = r.bool();
          continue;
        case 3:
          if (t !== 24)
            break;
          i.cancelFutureDowngrade = r.bool();
          continue;
        case 4:
          if (t !== 34)
            break;
          i.reason = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Cn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Se();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n.startInFreeTrialNoObligationState = e.startInFreeTrialNoObligationState ?? void 0, n.cancelFutureDowngrade = e.cancelFutureDowngrade ?? void 0, n.reason = e.reason ?? void 0, n;
  }
};
function qe() {
  return { $type: "squareup.sub2.service.v3.external.ExternalUpdateSubscriptionResponse", subscription: void 0 };
}
const On = {
  $type: "squareup.sub2.service.v3.external.ExternalUpdateSubscriptionResponse",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = qe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return On.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = qe();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n;
  }
};
function ye() {
  return { $type: "squareup.sub2.service.v3.external.ExternalActivatePresaleSubscriptionsRequest", reason: void 0 };
}
const Fn = {
  $type: "squareup.sub2.service.v3.external.ExternalActivatePresaleSubscriptionsRequest",
  encode(e, n = s.Writer.create()) {
    return e.reason !== void 0 && n.uint32(10).string(e.reason), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ye();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.reason = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Fn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ye();
    return n.reason = e.reason ?? void 0, n;
  }
};
function Te() {
  return { $type: "squareup.sub2.service.v3.external.ExternalActivatePresaleSubscriptionsResponse", subscriptions: [] };
}
const $n = {
  $type: "squareup.sub2.service.v3.external.ExternalActivatePresaleSubscriptionsResponse",
  encode(e, n = s.Writer.create()) {
    for (const r of e.subscriptions)
      u.encode(r, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Te();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscriptions.push(u.decode(r, r.uint32()));
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return $n.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const n = Te();
    return n.subscriptions = ((r = e.subscriptions) == null ? void 0 : r.map((a) => u.fromPartial(a))) || [], n;
  }
};
function ge() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalCreateBundleRequest",
    reason: void 0,
    bundleOfferingToken: void 0
  };
}
const Ln = {
  $type: "squareup.sub2.service.v3.external.ExternalCreateBundleRequest",
  encode(e, n = s.Writer.create()) {
    return e.reason !== void 0 && n.uint32(10).string(e.reason), e.bundleOfferingToken !== void 0 && n.uint32(18).string(e.bundleOfferingToken), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ge();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.reason = r.string();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.bundleOfferingToken = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Ln.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ge();
    return n.reason = e.reason ?? void 0, n.bundleOfferingToken = e.bundleOfferingToken ?? void 0, n;
  }
};
function Ge() {
  return { $type: "squareup.sub2.service.v3.external.ExternalCreateBundleResponse", bundle: void 0 };
}
const An = {
  $type: "squareup.sub2.service.v3.external.ExternalCreateBundleResponse",
  encode(e, n = s.Writer.create()) {
    return e.bundle !== void 0 && o.encode(e.bundle, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ge();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.bundle = o.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return An.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ge();
    return n.bundle = e.bundle !== void 0 && e.bundle !== null ? o.fromPartial(e.bundle) : void 0, n;
  }
};
function Be() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalCancelBundleRequest",
    reason: void 0,
    bundleToken: void 0
  };
}
const Dn = {
  $type: "squareup.sub2.service.v3.external.ExternalCancelBundleRequest",
  encode(e, n = s.Writer.create()) {
    return e.reason !== void 0 && n.uint32(10).string(e.reason), e.bundleToken !== void 0 && n.uint32(18).string(e.bundleToken), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Be();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.reason = r.string();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.bundleToken = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Dn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Be();
    return n.reason = e.reason ?? void 0, n.bundleToken = e.bundleToken ?? void 0, n;
  }
};
function Ce() {
  return { $type: "squareup.sub2.service.v3.external.ExternalCancelBundleResponse", bundle: void 0 };
}
const In = {
  $type: "squareup.sub2.service.v3.external.ExternalCancelBundleResponse",
  encode(e, n = s.Writer.create()) {
    return e.bundle !== void 0 && o.encode(e.bundle, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ce();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.bundle = o.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return In.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ce();
    return n.bundle = e.bundle !== void 0 && e.bundle !== null ? o.fromPartial(e.bundle) : void 0, n;
  }
};
function Oe() {
  return { $type: "squareup.sub2.service.v3.external.ExternalGetBundleRequest", bundleToken: void 0 };
}
const Wn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetBundleRequest",
  encode(e, n = s.Writer.create()) {
    return e.bundleToken !== void 0 && n.uint32(10).string(e.bundleToken), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Oe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.bundleToken = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Wn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Oe();
    return n.bundleToken = e.bundleToken ?? void 0, n;
  }
};
function Fe() {
  return { $type: "squareup.sub2.service.v3.external.ExternalGetBundleResponse", bundle: void 0 };
}
const Un = {
  $type: "squareup.sub2.service.v3.external.ExternalGetBundleResponse",
  encode(e, n = s.Writer.create()) {
    return e.bundle !== void 0 && o.encode(e.bundle, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Fe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.bundle = o.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Un.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Fe();
    return n.bundle = e.bundle !== void 0 && e.bundle !== null ? o.fromPartial(e.bundle) : void 0, n;
  }
};
function $e() {
  return { $type: "squareup.sub2.service.v3.external.ExternalListAvailableBundleOfferingsRequest" };
}
const Mn = {
  $type: "squareup.sub2.service.v3.external.ExternalListAvailableBundleOfferingsRequest",
  encode(e, n = s.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = $e();
    for (; r.pos < a; ) {
      const t = r.uint32();
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Mn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return $e();
  }
};
function Le() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalListAvailableBundleOfferingsResponse",
    bundleOfferings: []
  };
}
const wn = {
  $type: "squareup.sub2.service.v3.external.ExternalListAvailableBundleOfferingsResponse",
  encode(e, n = s.Writer.create()) {
    for (const r of e.bundleOfferings)
      w.encode(r, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Le();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.bundleOfferings.push(w.decode(r, r.uint32()));
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return wn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const n = Le();
    return n.bundleOfferings = ((r = e.bundleOfferings) == null ? void 0 : r.map((a) => w.fromPartial(a))) || [], n;
  }
};
function Ae() {
  return { $type: "squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffRequest", planChanges: [] };
}
const Nn = {
  $type: "squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffRequest",
  encode(e, n = s.Writer.create()) {
    for (const r of e.planChanges)
      V.encode(r, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ae();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.planChanges.push(V.decode(r, r.uint32()));
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Nn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const n = Ae();
    return n.planChanges = ((r = e.planChanges) == null ? void 0 : r.map((a) => V.fromPartial(a))) || [], n;
  }
};
function De() {
  return { $type: "squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffResponse", featureDiffs: [] };
}
const _n = {
  $type: "squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffResponse",
  encode(e, n = s.Writer.create()) {
    for (const r of e.featureDiffs)
      E.encode(r, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = De();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.featureDiffs.push(E.decode(r, r.uint32()));
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return _n.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const n = De();
    return n.featureDiffs = ((r = e.featureDiffs) == null ? void 0 : r.map((a) => E.fromPartial(a))) || [], n;
  }
};
function Ie() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffResponse.FeatureDiff",
    succeeded: void 0,
    featuresLost: [],
    featuresMaintained: [],
    featuresGained: [],
    errorMessage: void 0
  };
}
const E = {
  $type: "squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffResponse.FeatureDiff",
  encode(e, n = s.Writer.create()) {
    e.succeeded !== void 0 && n.uint32(8).bool(e.succeeded);
    for (const r of e.featuresLost)
      d.encode(r, n.uint32(18).fork()).ldelim();
    for (const r of e.featuresMaintained)
      d.encode(r, n.uint32(26).fork()).ldelim();
    for (const r of e.featuresGained)
      d.encode(r, n.uint32(34).fork()).ldelim();
    return e.errorMessage !== void 0 && n.uint32(42).string(e.errorMessage), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ie();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 8)
            break;
          i.succeeded = r.bool();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.featuresLost.push(d.decode(r, r.uint32()));
          continue;
        case 3:
          if (t !== 26)
            break;
          i.featuresMaintained.push(d.decode(r, r.uint32()));
          continue;
        case 4:
          if (t !== 34)
            break;
          i.featuresGained.push(d.decode(r, r.uint32()));
          continue;
        case 5:
          if (t !== 42)
            break;
          i.errorMessage = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return E.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r, a, i;
    const n = Ie();
    return n.succeeded = e.succeeded ?? void 0, n.featuresLost = ((r = e.featuresLost) == null ? void 0 : r.map((t) => d.fromPartial(t))) || [], n.featuresMaintained = ((a = e.featuresMaintained) == null ? void 0 : a.map((t) => d.fromPartial(t))) || [], n.featuresGained = ((i = e.featuresGained) == null ? void 0 : i.map((t) => d.fromPartial(t))) || [], n.errorMessage = e.errorMessage ?? void 0, n;
  }
};
function We() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetFeedbackOptionListForPlanRequest",
    planToken: void 0
  };
}
const Kn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetFeedbackOptionListForPlanRequest",
  encode(e, n = s.Writer.create()) {
    return e.planToken !== void 0 && n.uint32(10).string(e.planToken), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = We();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.planToken = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Kn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = We();
    return n.planToken = e.planToken ?? void 0, n;
  }
};
function Ue() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetFeedbackOptionListForPlanResponse",
    feedbackOptionList: void 0
  };
}
const Qn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetFeedbackOptionListForPlanResponse",
  encode(e, n = s.Writer.create()) {
    return e.feedbackOptionList !== void 0 && N.encode(e.feedbackOptionList, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ue();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.feedbackOptionList = N.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Qn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ue();
    return n.feedbackOptionList = e.feedbackOptionList !== void 0 && e.feedbackOptionList !== null ? N.fromPartial(e.feedbackOptionList) : void 0, n;
  }
};
function Me() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetFutureSubscribedFeatureDiffRequest",
    oldPlanTokens: [],
    newPlanTokens: []
  };
}
const Vn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetFutureSubscribedFeatureDiffRequest",
  encode(e, n = s.Writer.create()) {
    for (const r of e.oldPlanTokens)
      n.uint32(10).string(r);
    for (const r of e.newPlanTokens)
      n.uint32(18).string(r);
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Me();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.oldPlanTokens.push(r.string());
          continue;
        case 2:
          if (t !== 18)
            break;
          i.newPlanTokens.push(r.string());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Vn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r, a;
    const n = Me();
    return n.oldPlanTokens = ((r = e.oldPlanTokens) == null ? void 0 : r.map((i) => i)) || [], n.newPlanTokens = ((a = e.newPlanTokens) == null ? void 0 : a.map((i) => i)) || [], n;
  }
};
function we() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetFutureSubscribedFeatureDiffResponse",
    futureSubscribedFeatures: [],
    futureSubscribedFeaturesWithPlanChange: []
  };
}
const Yn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetFutureSubscribedFeatureDiffResponse",
  encode(e, n = s.Writer.create()) {
    n.uint32(10).fork();
    for (const r of e.futureSubscribedFeatures)
      n.int32(r);
    n.ldelim(), n.uint32(18).fork();
    for (const r of e.futureSubscribedFeaturesWithPlanChange)
      n.int32(r);
    return n.ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = we();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t === 8) {
            i.futureSubscribedFeatures.push(r.int32());
            continue;
          }
          if (t === 10) {
            const x = r.uint32() + r.pos;
            for (; r.pos < x; )
              i.futureSubscribedFeatures.push(r.int32());
            continue;
          }
          break;
        case 2:
          if (t === 16) {
            i.futureSubscribedFeaturesWithPlanChange.push(r.int32());
            continue;
          }
          if (t === 18) {
            const x = r.uint32() + r.pos;
            for (; r.pos < x; )
              i.futureSubscribedFeaturesWithPlanChange.push(r.int32());
            continue;
          }
          break;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Yn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r, a;
    const n = we();
    return n.futureSubscribedFeatures = ((r = e.futureSubscribedFeatures) == null ? void 0 : r.map((i) => i)) || [], n.futureSubscribedFeaturesWithPlanChange = ((a = e.futureSubscribedFeaturesWithPlanChange) == null ? void 0 : a.map((i) => i)) || [], n;
  }
};
function Ne() {
  return { $type: "squareup.sub2.service.v3.external.ExternalSyncSquareOneAvtBucketingResultRequest", avt: void 0 };
}
const zn = {
  $type: "squareup.sub2.service.v3.external.ExternalSyncSquareOneAvtBucketingResultRequest",
  encode(e, n = s.Writer.create()) {
    return e.avt !== void 0 && n.uint32(10).string(e.avt), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ne();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.avt = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return zn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ne();
    return n.avt = e.avt ?? void 0, n;
  }
};
function _e() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalSyncSquareOneAvtBucketingResultResponse",
    avtBucketed: void 0,
    squareOneEligibility: void 0
  };
}
const Hn = {
  $type: "squareup.sub2.service.v3.external.ExternalSyncSquareOneAvtBucketingResultResponse",
  encode(e, n = s.Writer.create()) {
    return e.avtBucketed !== void 0 && n.uint32(8).bool(e.avtBucketed), e.squareOneEligibility !== void 0 && f.encode(e.squareOneEligibility, n.uint32(18).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = _e();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 8)
            break;
          i.avtBucketed = r.bool();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.squareOneEligibility = f.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Hn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = _e();
    return n.avtBucketed = e.avtBucketed ?? void 0, n.squareOneEligibility = e.squareOneEligibility !== void 0 && e.squareOneEligibility !== null ? f.fromPartial(e.squareOneEligibility) : void 0, n;
  }
};
function Ke() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetOrSetSquareOneEligibilityRequest",
    eligibilityQualifier: void 0
  };
}
const Jn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetOrSetSquareOneEligibilityRequest",
  encode(e, n = s.Writer.create()) {
    return e.eligibilityQualifier !== void 0 && I.encode(e.eligibilityQualifier, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ke();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.eligibilityQualifier = I.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Jn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ke();
    return n.eligibilityQualifier = e.eligibilityQualifier !== void 0 && e.eligibilityQualifier !== null ? I.fromPartial(e.eligibilityQualifier) : void 0, n;
  }
};
function Qe() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetOrSetSquareOneEligibilityResponse",
    squareOneEligibility: void 0
  };
}
const Xn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetOrSetSquareOneEligibilityResponse",
  encode(e, n = s.Writer.create()) {
    return e.squareOneEligibility !== void 0 && f.encode(e.squareOneEligibility, n.uint32(10).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Qe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.squareOneEligibility = f.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Xn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Qe();
    return n.squareOneEligibility = e.squareOneEligibility !== void 0 && e.squareOneEligibility !== null ? f.fromPartial(e.squareOneEligibility) : void 0, n;
  }
};
function Ve() {
  return { $type: "squareup.sub2.service.v3.external.ExternalGetTierRecommendationRequest", planGroupToken: void 0 };
}
const Zn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetTierRecommendationRequest",
  encode(e, n = s.Writer.create()) {
    return e.planGroupToken !== void 0 && n.uint32(10).string(e.planGroupToken), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ve();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.planGroupToken = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return Zn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ve();
    return n.planGroupToken = e.planGroupToken ?? void 0, n;
  }
};
function Ye() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetTierRecommendationResponse",
    recommendedPlanToken: void 0
  };
}
const jn = {
  $type: "squareup.sub2.service.v3.external.ExternalGetTierRecommendationResponse",
  encode(e, n = s.Writer.create()) {
    return e.recommendedPlanToken !== void 0 && n.uint32(10).string(e.recommendedPlanToken), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ye();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.recommendedPlanToken = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return jn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ye();
    return n.recommendedPlanToken = e.recommendedPlanToken ?? void 0, n;
  }
};
function ze() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetSquareOneSubscriptionInfoRequest",
    includePlanInfo: void 0
  };
}
const er = {
  $type: "squareup.sub2.service.v3.external.ExternalGetSquareOneSubscriptionInfoRequest",
  encode(e, n = s.Writer.create()) {
    return e.includePlanInfo !== void 0 && n.uint32(8).bool(e.includePlanInfo), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = ze();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 8)
            break;
          i.includePlanInfo = r.bool();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return er.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ze();
    return n.includePlanInfo = e.includePlanInfo ?? void 0, n;
  }
};
function He() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetSquareOneSubscriptionInfoResponse",
    subscription: void 0,
    recommendedTierPlanToken: void 0,
    freeTierPlanToken: void 0,
    planGroup: void 0
  };
}
const nr = {
  $type: "squareup.sub2.service.v3.external.ExternalGetSquareOneSubscriptionInfoResponse",
  encode(e, n = s.Writer.create()) {
    return e.subscription !== void 0 && u.encode(e.subscription, n.uint32(10).fork()).ldelim(), e.recommendedTierPlanToken !== void 0 && n.uint32(18).string(e.recommendedTierPlanToken), e.freeTierPlanToken !== void 0 && n.uint32(26).string(e.freeTierPlanToken), e.planGroup !== void 0 && p.encode(e.planGroup, n.uint32(34).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = He();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.subscription = u.decode(r, r.uint32());
          continue;
        case 2:
          if (t !== 18)
            break;
          i.recommendedTierPlanToken = r.string();
          continue;
        case 3:
          if (t !== 26)
            break;
          i.freeTierPlanToken = r.string();
          continue;
        case 4:
          if (t !== 34)
            break;
          i.planGroup = p.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return nr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = He();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? u.fromPartial(e.subscription) : void 0, n.recommendedTierPlanToken = e.recommendedTierPlanToken ?? void 0, n.freeTierPlanToken = e.freeTierPlanToken ?? void 0, n.planGroup = e.planGroup !== void 0 && e.planGroup !== null ? p.fromPartial(e.planGroup) : void 0, n;
  }
};
function Je() {
  return { $type: "squareup.sub2.service.v3.external.ExternalListTrialsRequest", planGroupToken: void 0 };
}
const rr = {
  $type: "squareup.sub2.service.v3.external.ExternalListTrialsRequest",
  encode(e, n = s.Writer.create()) {
    return e.planGroupToken !== void 0 && n.uint32(10).string(e.planGroupToken), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Je();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.planGroupToken = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return rr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Je();
    return n.planGroupToken = e.planGroupToken ?? void 0, n;
  }
};
function Xe() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalListTrialsResponse",
    activeTrial: void 0,
    availableTrials: [],
    consumedTrials: []
  };
}
const tr = {
  $type: "squareup.sub2.service.v3.external.ExternalListTrialsResponse",
  encode(e, n = s.Writer.create()) {
    e.activeTrial !== void 0 && O.encode(e.activeTrial, n.uint32(10).fork()).ldelim();
    for (const r of e.availableTrials)
      F.encode(r, n.uint32(18).fork()).ldelim();
    for (const r of e.consumedTrials)
      $.encode(r, n.uint32(26).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Xe();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.activeTrial = O.decode(r, r.uint32());
          continue;
        case 2:
          if (t !== 18)
            break;
          i.availableTrials.push(F.decode(r, r.uint32()));
          continue;
        case 3:
          if (t !== 26)
            break;
          i.consumedTrials.push($.decode(r, r.uint32()));
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return tr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r, a;
    const n = Xe();
    return n.activeTrial = e.activeTrial !== void 0 && e.activeTrial !== null ? O.fromPartial(e.activeTrial) : void 0, n.availableTrials = ((r = e.availableTrials) == null ? void 0 : r.map((i) => F.fromPartial(i))) || [], n.consumedTrials = ((a = e.consumedTrials) == null ? void 0 : a.map((i) => $.fromPartial(i))) || [], n;
  }
};
function Ze() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetUiAssetsRequest",
    planGroupToken: void 0,
    locale: void 0,
    ui: [],
    subaudience: void 0
  };
}
const ir = {
  $type: "squareup.sub2.service.v3.external.ExternalGetUiAssetsRequest",
  encode(e, n = s.Writer.create()) {
    e.planGroupToken !== void 0 && n.uint32(10).string(e.planGroupToken), e.locale !== void 0 && n.uint32(18).string(e.locale), n.uint32(26).fork();
    for (const r of e.ui)
      n.int32(r);
    return n.ldelim(), e.subaudience !== void 0 && n.uint32(32).int32(e.subaudience), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = Ze();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.planGroupToken = r.string();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.locale = r.string();
          continue;
        case 3:
          if (t === 24) {
            i.ui.push(r.int32());
            continue;
          }
          if (t === 26) {
            const x = r.uint32() + r.pos;
            for (; r.pos < x; )
              i.ui.push(r.int32());
            continue;
          }
          break;
        case 4:
          if (t !== 32)
            break;
          i.subaudience = r.int32();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return ir.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const n = Ze();
    return n.planGroupToken = e.planGroupToken ?? void 0, n.locale = e.locale ?? void 0, n.ui = ((r = e.ui) == null ? void 0 : r.map((a) => a)) || [], n.subaudience = e.subaudience ?? void 0, n;
  }
};
function je() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalGetUiAssetsResponse",
    fullPagePaywall: void 0,
    modal: void 0,
    paywallCard: void 0,
    downgrade: void 0,
    trialWelcome: void 0,
    trialExpiring: void 0,
    trialExpired: void 0
  };
}
const sr = {
  $type: "squareup.sub2.service.v3.external.ExternalGetUiAssetsResponse",
  encode(e, n = s.Writer.create()) {
    return e.fullPagePaywall !== void 0 && q.encode(e.fullPagePaywall, n.uint32(10).fork()).ldelim(), e.modal !== void 0 && y.encode(e.modal, n.uint32(18).fork()).ldelim(), e.paywallCard !== void 0 && T.encode(e.paywallCard, n.uint32(26).fork()).ldelim(), e.downgrade !== void 0 && g.encode(e.downgrade, n.uint32(34).fork()).ldelim(), e.trialWelcome !== void 0 && G.encode(e.trialWelcome, n.uint32(42).fork()).ldelim(), e.trialExpiring !== void 0 && B.encode(e.trialExpiring, n.uint32(50).fork()).ldelim(), e.trialExpired !== void 0 && C.encode(e.trialExpired, n.uint32(58).fork()).ldelim(), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = je();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          i.fullPagePaywall = q.decode(r, r.uint32());
          continue;
        case 2:
          if (t !== 18)
            break;
          i.modal = y.decode(r, r.uint32());
          continue;
        case 3:
          if (t !== 26)
            break;
          i.paywallCard = T.decode(r, r.uint32());
          continue;
        case 4:
          if (t !== 34)
            break;
          i.downgrade = g.decode(r, r.uint32());
          continue;
        case 5:
          if (t !== 42)
            break;
          i.trialWelcome = G.decode(r, r.uint32());
          continue;
        case 6:
          if (t !== 50)
            break;
          i.trialExpiring = B.decode(r, r.uint32());
          continue;
        case 7:
          if (t !== 58)
            break;
          i.trialExpired = C.decode(r, r.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return sr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = je();
    return n.fullPagePaywall = e.fullPagePaywall !== void 0 && e.fullPagePaywall !== null ? q.fromPartial(e.fullPagePaywall) : void 0, n.modal = e.modal !== void 0 && e.modal !== null ? y.fromPartial(e.modal) : void 0, n.paywallCard = e.paywallCard !== void 0 && e.paywallCard !== null ? T.fromPartial(e.paywallCard) : void 0, n.downgrade = e.downgrade !== void 0 && e.downgrade !== null ? g.fromPartial(e.downgrade) : void 0, n.trialWelcome = e.trialWelcome !== void 0 && e.trialWelcome !== null ? G.fromPartial(e.trialWelcome) : void 0, n.trialExpiring = e.trialExpiring !== void 0 && e.trialExpiring !== null ? B.fromPartial(e.trialExpiring) : void 0, n.trialExpired = e.trialExpired !== void 0 && e.trialExpired !== null ? C.fromPartial(e.trialExpired) : void 0, n;
  }
};
function en() {
  return { $type: "squareup.sub2.service.v3.external.ExternalSyncBillableLocationRequest" };
}
const ar = {
  $type: "squareup.sub2.service.v3.external.ExternalSyncBillableLocationRequest",
  encode(e, n = s.Writer.create()) {
    return n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = en();
    for (; r.pos < a; ) {
      const t = r.uint32();
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return ar.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return en();
  }
};
function nn() {
  return {
    $type: "squareup.sub2.service.v3.external.ExternalSyncBillableLocationResponse",
    succeeded: void 0,
    errorMessage: void 0
  };
}
const ur = {
  $type: "squareup.sub2.service.v3.external.ExternalSyncBillableLocationResponse",
  encode(e, n = s.Writer.create()) {
    return e.succeeded !== void 0 && n.uint32(8).bool(e.succeeded), e.errorMessage !== void 0 && n.uint32(18).string(e.errorMessage), n;
  },
  decode(e, n) {
    const r = e instanceof s.Reader ? e : s.Reader.create(e);
    let a = n === void 0 ? r.len : r.pos + n;
    const i = nn();
    for (; r.pos < a; ) {
      const t = r.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 8)
            break;
          i.succeeded = r.bool();
          continue;
        case 2:
          if (t !== 18)
            break;
          i.errorMessage = r.string();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      r.skipType(t & 7);
    }
    return i;
  },
  create(e) {
    return ur.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = nn();
    return n.succeeded = e.succeeded ?? void 0, n.errorMessage = e.errorMessage ?? void 0, n;
  }
}, lr = "squareup.sub2.service.v3.external.ExternalSubscriptionService";
class vr {
  constructor(n, r) {
    v(this, "rpc");
    v(this, "service");
    this.service = (r == null ? void 0 : r.service) || lr, this.rpc = n, this.externalBatchCreateAndCancelSubscriptions = this.externalBatchCreateAndCancelSubscriptions.bind(this), this.externalCancelSubscription = this.externalCancelSubscription.bind(this), this.externalPauseSubscription = this.externalPauseSubscription.bind(this), this.externalResumeSubscription = this.externalResumeSubscription.bind(this), this.externalCreateOrUpdateSubscription = this.externalCreateOrUpdateSubscription.bind(this), this.externalGetBillerLocationToken = this.externalGetBillerLocationToken.bind(this), this.externalGetDefaultPricingInfo = this.externalGetDefaultPricingInfo.bind(this), this.externalGetPlanComponents = this.externalGetPlanComponents.bind(this), this.externalGetPricingInfo = this.externalGetPricingInfo.bind(this), this.externalGetSubscription = this.externalGetSubscription.bind(this), this.externalIsSubscribedToFeature = this.externalIsSubscribedToFeature.bind(this), this.externalListFeatureStatuses = this.externalListFeatureStatuses.bind(this), this.externalListMergedSubscriptions = this.externalListMergedSubscriptions.bind(this), this.externalGetPlanGroup = this.externalGetPlanGroup.bind(this), this.externalUpdateSubscription = this.externalUpdateSubscription.bind(this), this.externalActivatePresaleSubscriptions = this.externalActivatePresaleSubscriptions.bind(this), this.externalCreateBundle = this.externalCreateBundle.bind(this), this.externalCancelBundle = this.externalCancelBundle.bind(this), this.externalGetBundle = this.externalGetBundle.bind(this), this.externalListAvailableBundleOfferings = this.externalListAvailableBundleOfferings.bind(this), this.externalBulkGetFeatureDiff = this.externalBulkGetFeatureDiff.bind(this), this.externalGetFeedbackOptionListForPlan = this.externalGetFeedbackOptionListForPlan.bind(this), this.externalGetFutureSubscribedFeatureDiff = this.externalGetFutureSubscribedFeatureDiff.bind(this), this.externalSyncSquareOneAvtBucketingResult = this.externalSyncSquareOneAvtBucketingResult.bind(this), this.externalGetOrSetSquareOneEligibility = this.externalGetOrSetSquareOneEligibility.bind(this), this.externalGetTierRecommendation = this.externalGetTierRecommendation.bind(this), this.externalGetSquareOneSubscriptionInfo = this.externalGetSquareOneSubscriptionInfo.bind(this), this.externalListTrials = this.externalListTrials.bind(this), this.externalGetUiAssets = this.externalGetUiAssets.bind(this), this.externalSyncBillableLocation = this.externalSyncBillableLocation.bind(this);
  }
  externalBatchCreateAndCancelSubscriptions(n) {
    const r = rn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalBatchCreateAndCancelSubscriptions", n), this.rpc.request(this.service, "ExternalBatchCreateAndCancelSubscriptions", r).then((i) => {
      try {
        const t = tn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalBatchCreateAndCancelSubscriptions", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalBatchCreateAndCancelSubscriptions", i)) : Promise.reject(i));
  }
  externalCancelSubscription(n) {
    const r = sn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalCancelSubscription", n), this.rpc.request(this.service, "ExternalCancelSubscription", r).then((i) => {
      try {
        const t = an.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalCancelSubscription", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalCancelSubscription", i)) : Promise.reject(i));
  }
  externalPauseSubscription(n) {
    const r = un.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalPauseSubscription", n), this.rpc.request(this.service, "ExternalPauseSubscription", r).then((i) => {
      try {
        const t = cn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalPauseSubscription", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalPauseSubscription", i)) : Promise.reject(i));
  }
  externalResumeSubscription(n) {
    const r = on.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalResumeSubscription", n), this.rpc.request(this.service, "ExternalResumeSubscription", r).then((i) => {
      try {
        const t = dn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalResumeSubscription", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalResumeSubscription", i)) : Promise.reject(i));
  }
  externalCreateOrUpdateSubscription(n) {
    const r = ln.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalCreateOrUpdateSubscription", n), this.rpc.request(this.service, "ExternalCreateOrUpdateSubscription", r).then((i) => {
      try {
        const t = fn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalCreateOrUpdateSubscription", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalCreateOrUpdateSubscription", i)) : Promise.reject(i));
  }
  externalGetBillerLocationToken(n) {
    const r = pn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetBillerLocationToken", n), this.rpc.request(this.service, "ExternalGetBillerLocationToken", r).then((i) => {
      try {
        const t = bn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetBillerLocationToken", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetBillerLocationToken", i)) : Promise.reject(i));
  }
  externalGetDefaultPricingInfo(n) {
    const r = hn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetDefaultPricingInfo", n), this.rpc.request(this.service, "ExternalGetDefaultPricingInfo", r).then((i) => {
      try {
        const t = xn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetDefaultPricingInfo", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetDefaultPricingInfo", i)) : Promise.reject(i));
  }
  externalGetPlanComponents(n) {
    const r = mn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetPlanComponents", n), this.rpc.request(this.service, "ExternalGetPlanComponents", r).then((i) => {
      try {
        const t = Rn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetPlanComponents", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetPlanComponents", i)) : Promise.reject(i));
  }
  externalGetPricingInfo(n) {
    const r = kn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetPricingInfo", n), this.rpc.request(this.service, "ExternalGetPricingInfo", r).then((i) => {
      try {
        const t = En.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetPricingInfo", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetPricingInfo", i)) : Promise.reject(i));
  }
  externalGetSubscription(n) {
    const r = vn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetSubscription", n), this.rpc.request(this.service, "ExternalGetSubscription", r).then((i) => {
      try {
        const t = Pn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetSubscription", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetSubscription", i)) : Promise.reject(i));
  }
  externalIsSubscribedToFeature(n) {
    const r = Sn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalIsSubscribedToFeature", n), this.rpc.request(this.service, "ExternalIsSubscribedToFeature", r).then((i) => {
      try {
        const t = qn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalIsSubscribedToFeature", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalIsSubscribedToFeature", i)) : Promise.reject(i));
  }
  externalListFeatureStatuses(n) {
    const r = yn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalListFeatureStatuses", n), this.rpc.request(this.service, "ExternalListFeatureStatuses", r).then((i) => {
      try {
        const t = dr.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalListFeatureStatuses", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalListFeatureStatuses", i)) : Promise.reject(i));
  }
  externalListMergedSubscriptions(n) {
    const r = Tn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalListMergedSubscriptions", n), this.rpc.request(this.service, "ExternalListMergedSubscriptions", r).then((i) => {
      try {
        const t = gn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalListMergedSubscriptions", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalListMergedSubscriptions", i)) : Promise.reject(i));
  }
  externalGetPlanGroup(n) {
    const r = Gn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetPlanGroup", n), this.rpc.request(this.service, "ExternalGetPlanGroup", r).then((i) => {
      try {
        const t = Bn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetPlanGroup", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetPlanGroup", i)) : Promise.reject(i));
  }
  externalUpdateSubscription(n) {
    const r = Cn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalUpdateSubscription", n), this.rpc.request(this.service, "ExternalUpdateSubscription", r).then((i) => {
      try {
        const t = On.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalUpdateSubscription", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalUpdateSubscription", i)) : Promise.reject(i));
  }
  externalActivatePresaleSubscriptions(n) {
    const r = Fn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalActivatePresaleSubscriptions", n), this.rpc.request(this.service, "ExternalActivatePresaleSubscriptions", r).then((i) => {
      try {
        const t = $n.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalActivatePresaleSubscriptions", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalActivatePresaleSubscriptions", i)) : Promise.reject(i));
  }
  externalCreateBundle(n) {
    const r = Ln.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalCreateBundle", n), this.rpc.request(this.service, "ExternalCreateBundle", r).then((i) => {
      try {
        const t = An.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalCreateBundle", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalCreateBundle", i)) : Promise.reject(i));
  }
  externalCancelBundle(n) {
    const r = Dn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalCancelBundle", n), this.rpc.request(this.service, "ExternalCancelBundle", r).then((i) => {
      try {
        const t = In.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalCancelBundle", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalCancelBundle", i)) : Promise.reject(i));
  }
  externalGetBundle(n) {
    const r = Wn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetBundle", n), this.rpc.request(this.service, "ExternalGetBundle", r).then((i) => {
      try {
        const t = Un.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetBundle", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetBundle", i)) : Promise.reject(i));
  }
  externalListAvailableBundleOfferings(n) {
    const r = Mn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalListAvailableBundleOfferings", n), this.rpc.request(this.service, "ExternalListAvailableBundleOfferings", r).then((i) => {
      try {
        const t = wn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalListAvailableBundleOfferings", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalListAvailableBundleOfferings", i)) : Promise.reject(i));
  }
  externalBulkGetFeatureDiff(n) {
    const r = Nn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalBulkGetFeatureDiff", n), this.rpc.request(this.service, "ExternalBulkGetFeatureDiff", r).then((i) => {
      try {
        const t = _n.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalBulkGetFeatureDiff", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalBulkGetFeatureDiff", i)) : Promise.reject(i));
  }
  externalGetFeedbackOptionListForPlan(n) {
    const r = Kn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetFeedbackOptionListForPlan", n), this.rpc.request(this.service, "ExternalGetFeedbackOptionListForPlan", r).then((i) => {
      try {
        const t = Qn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetFeedbackOptionListForPlan", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetFeedbackOptionListForPlan", i)) : Promise.reject(i));
  }
  externalGetFutureSubscribedFeatureDiff(n) {
    const r = Vn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetFutureSubscribedFeatureDiff", n), this.rpc.request(this.service, "ExternalGetFutureSubscribedFeatureDiff", r).then((i) => {
      try {
        const t = Yn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetFutureSubscribedFeatureDiff", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetFutureSubscribedFeatureDiff", i)) : Promise.reject(i));
  }
  externalSyncSquareOneAvtBucketingResult(n) {
    const r = zn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalSyncSquareOneAvtBucketingResult", n), this.rpc.request(this.service, "ExternalSyncSquareOneAvtBucketingResult", r).then((i) => {
      try {
        const t = Hn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalSyncSquareOneAvtBucketingResult", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalSyncSquareOneAvtBucketingResult", i)) : Promise.reject(i));
  }
  externalGetOrSetSquareOneEligibility(n) {
    const r = Jn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetOrSetSquareOneEligibility", n), this.rpc.request(this.service, "ExternalGetOrSetSquareOneEligibility", r).then((i) => {
      try {
        const t = Xn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetOrSetSquareOneEligibility", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetOrSetSquareOneEligibility", i)) : Promise.reject(i));
  }
  externalGetTierRecommendation(n) {
    const r = Zn.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetTierRecommendation", n), this.rpc.request(this.service, "ExternalGetTierRecommendation", r).then((i) => {
      try {
        const t = jn.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetTierRecommendation", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetTierRecommendation", i)) : Promise.reject(i));
  }
  externalGetSquareOneSubscriptionInfo(n) {
    const r = er.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetSquareOneSubscriptionInfo", n), this.rpc.request(this.service, "ExternalGetSquareOneSubscriptionInfo", r).then((i) => {
      try {
        const t = nr.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetSquareOneSubscriptionInfo", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetSquareOneSubscriptionInfo", i)) : Promise.reject(i));
  }
  externalListTrials(n) {
    const r = rr.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalListTrials", n), this.rpc.request(this.service, "ExternalListTrials", r).then((i) => {
      try {
        const t = tr.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalListTrials", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalListTrials", i)) : Promise.reject(i));
  }
  externalGetUiAssets(n) {
    const r = ir.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalGetUiAssets", n), this.rpc.request(this.service, "ExternalGetUiAssets", r).then((i) => {
      try {
        const t = sr.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalGetUiAssets", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalGetUiAssets", i)) : Promise.reject(i));
  }
  externalSyncBillableLocation(n) {
    const r = ar.encode(n).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ExternalSyncBillableLocation", n), this.rpc.request(this.service, "ExternalSyncBillableLocation", r).then((i) => {
      try {
        const t = ur.decode(s.Reader.create(i));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ExternalSyncBillableLocation", t), t;
      } catch (t) {
        return Promise.reject(t);
      }
    }).catch((i) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ExternalSyncBillableLocation", i)) : Promise.reject(i));
  }
}
const Pr = {
  methods: {
    /** Creates, re-activates, or changes the plan of a subscription. */
    externalCreateOrUpdateSubscription: {
      name: "ExternalCreateOrUpdateSubscription"
    },
    /** Retrieves the location token for a given country code, falling back to US. */
    externalGetBillerLocationToken: {
      name: "ExternalGetBillerLocationToken"
    },
    /** Returns the pricing info for a subscriber and a plan. */
    externalGetPricingInfo: {
      name: "ExternalGetPricingInfo"
    },
    /** Fetches a plan group for the given token. If a subscriber is provided, it enables extra data in the response. */
    externalGetPlanGroup: {
      name: "ExternalGetPlanGroup"
    },
    /** Updates a subscription. */
    externalUpdateSubscription: {
      name: "ExternalUpdateSubscription"
    },
    /** ExternalGetOrSetSquareOneEligibility is used to get or set the Square One eligibility for a merchant. */
    externalGetOrSetSquareOneEligibility: {
      name: "ExternalGetOrSetSquareOneEligibility"
    },
    /**
     * ExternalSquareOneSubscriptionInfo is used to obtain the subscription given plan group token (if exists) and recommend tier plan token
     * long with the free_tier_plan_token as a fallback for free tier.
     */
    externalGetSquareOneSubscriptionInfo: {
      name: "ExternalGetSquareOneSubscriptionInfo"
    },
    /** List trials for the logged in merchant */
    externalListTrials: {
      name: "ExternalListTrials"
    },
    /** Returns the assets for a given plan group, locale, and UI. */
    externalGetUiAssets: {
      name: "ExternalGetUiAssets"
    }
  }
};
export {
  Fn as ExternalActivatePresaleSubscriptionsRequest,
  $n as ExternalActivatePresaleSubscriptionsResponse,
  rn as ExternalBatchCreateAndCancelSubscriptionsRequest,
  tn as ExternalBatchCreateAndCancelSubscriptionsResponse,
  R as ExternalBatchCreateAndCancelSubscriptionsResponse_CanceledSubscription,
  m as ExternalBatchCreateAndCancelSubscriptionsResponse_CreatedSubscription,
  k as ExternalBatchCreateAndCancelSubscriptionsResponse_UpdatedSubscription,
  Nn as ExternalBulkGetFeatureDiffRequest,
  _n as ExternalBulkGetFeatureDiffResponse,
  E as ExternalBulkGetFeatureDiffResponse_FeatureDiff,
  Dn as ExternalCancelBundleRequest,
  In as ExternalCancelBundleResponse,
  sn as ExternalCancelSubscriptionRequest,
  an as ExternalCancelSubscriptionResponse,
  Ln as ExternalCreateBundleRequest,
  An as ExternalCreateBundleResponse,
  ln as ExternalCreateOrUpdateSubscriptionRequest,
  fn as ExternalCreateOrUpdateSubscriptionResponse,
  pn as ExternalGetBillerLocationTokenRequest,
  bn as ExternalGetBillerLocationTokenResponse,
  Wn as ExternalGetBundleRequest,
  Un as ExternalGetBundleResponse,
  hn as ExternalGetDefaultPricingInfoRequest,
  xn as ExternalGetDefaultPricingInfoResponse,
  Kn as ExternalGetFeedbackOptionListForPlanRequest,
  Qn as ExternalGetFeedbackOptionListForPlanResponse,
  Vn as ExternalGetFutureSubscribedFeatureDiffRequest,
  Yn as ExternalGetFutureSubscribedFeatureDiffResponse,
  Jn as ExternalGetOrSetSquareOneEligibilityRequest,
  Xn as ExternalGetOrSetSquareOneEligibilityResponse,
  mn as ExternalGetPlanComponentsRequest,
  Rn as ExternalGetPlanComponentsResponse,
  Gn as ExternalGetPlanGroupRequest,
  Bn as ExternalGetPlanGroupResponse,
  kn as ExternalGetPricingInfoRequest,
  En as ExternalGetPricingInfoResponse,
  er as ExternalGetSquareOneSubscriptionInfoRequest,
  nr as ExternalGetSquareOneSubscriptionInfoResponse,
  vn as ExternalGetSubscriptionRequest,
  Pn as ExternalGetSubscriptionResponse,
  Zn as ExternalGetTierRecommendationRequest,
  jn as ExternalGetTierRecommendationResponse,
  ir as ExternalGetUiAssetsRequest,
  sr as ExternalGetUiAssetsResponse,
  Sn as ExternalIsSubscribedToFeatureRequest,
  qn as ExternalIsSubscribedToFeatureResponse,
  Mn as ExternalListAvailableBundleOfferingsRequest,
  wn as ExternalListAvailableBundleOfferingsResponse,
  yn as ExternalListFeatureStatusesRequest,
  Tn as ExternalListMergedSubscriptionsRequest,
  gn as ExternalListMergedSubscriptionsResponse,
  rr as ExternalListTrialsRequest,
  tr as ExternalListTrialsResponse,
  un as ExternalPauseSubscriptionRequest,
  cn as ExternalPauseSubscriptionResponse,
  on as ExternalResumeSubscriptionRequest,
  dn as ExternalResumeSubscriptionResponse,
  vr as ExternalSubscriptionServiceClientImpl,
  Pr as ExternalSubscriptionServiceDefinition,
  lr as ExternalSubscriptionServiceServiceName,
  ar as ExternalSyncBillableLocationRequest,
  ur as ExternalSyncBillableLocationResponse,
  zn as ExternalSyncSquareOneAvtBucketingResultRequest,
  Hn as ExternalSyncSquareOneAvtBucketingResultResponse,
  Cn as ExternalUpdateSubscriptionRequest,
  On as ExternalUpdateSubscriptionResponse
};
